import * as commissionsStore from './store'

export function commissionsModule({ store }) {
  store.registerModule('commissions', { ...commissionsStore, namespaced: true })
}
